import React, { useEffect, useState } from "react";
import imgdekstop from "../../../images/AdobeStock_638524851.jpg";

import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const InputModal = ({ setIsVisible, slideGoDOwn }) => {
  const accessToken = localStorage.getItem("@user");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
  });

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(
        "https://htprdapi.hightable.ai/profile-members/profile",
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setFormData(response.data.data);
      if (accessToken) {
        if (
          response.data.data.first_name === null ||
          response.data.data.first_name === undefined ||
          response.data.data.first_name === "" ||
          response.data.data.last_name === null ||
          response.data.data.last_name === undefined ||
          response.data.data.last_name === ""
        ) {
          setIsVisible(true);
        }
      }
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
    }
  };

  useEffect(() => {
    if (accessToken) {
      fetchProfileData();
    }
  }, [accessToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name.toLowerCase()]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        "https://htprdapi.hightable.ai/profile-members/update",
        formData,
        {
          params: { access_token: accessToken },
          headers: { "Content-Type": "application/json" },
        }
      );
      window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
      console.log("Profile updated successfully:", response.data);
    } catch (error) {
      window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
    }
  };
  return (
    <div>
      <section className={`bodylogin`}>
        <div
          className="login-slide-up z-[50] "
          onClick={() => setIsVisible(false)}
        >
          <div
            className="bottom-touch-wrapper"
            onClick={(e) => e.stopPropagation()} // Prevents event from bubbling to the parent
          >
            <div className="close-btn-div">
              <div
                className="close-btn-wrapper cursor-pointer"
                onClick={(e) => {
                  // slideGoDOwn();
                  setIsVisible(false);
                }}
              >
                <Link className="w-embed" to={"/"}>
                  {/*?xml version="1.0" encoding="utf-8"?*/}

                  <svg
                    width="100%"
                    height="100%"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 122.881 122.88"
                    enableBackground="new 0 0 122.881 122.88"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        fill="#fff"
                        d="M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M81.719,36.226 c1.363-1.363,3.572-1.363,4.936,0c1.363,1.363,1.363,3.573,0,4.936L66.375,61.439l20.279,20.278c1.363,1.363,1.363,3.573,0,4.937 c-1.363,1.362-3.572,1.362-4.936,0L61.44,66.376L41.162,86.654c-1.362,1.362-3.573,1.362-4.936,0c-1.363-1.363-1.363-3.573,0-4.937 l20.278-20.278L36.226,41.162c-1.363-1.363-1.363-3.573,0-4.936c1.363-1.363,3.573-1.363,4.936,0L61.44,56.504L81.719,36.226 L81.719,36.226z"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
            </div>
            <div className="w-layout-grid login-page-grid">
              <div id="" className="login-page-grid-left">
                <img
                  src={imgdekstop}
                  loading="lazy"
                  alt=""
                  className="login-image-desktop w-full"
                />
              </div>
              <div
                id="w-node-_2be679b0-fc25-0cca-4da2-d6f34bfefdaa-749844cf"
                className="login-page-grid-right"
              >
                <div className="heading-8">Update Account Details</div>
                <div className="w-[90%] md:w-[40%] pb-10">
                  <div className="input-field-wrapper-edit-profile">
                    <div className="input-wrapper-edit-profile">
                      <input
                        className="form-field-edit-profile w-input"
                        maxLength={256}
                        name="first_name"
                        placeholder="First Name"
                        type="text"
                        id="Name-3"
                        value={formData?.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>{" "}
                  <div className="input-field-wrapper-edit-profile">
                    <div className="input-wrapper-edit-profile">
                      <input
                        className="form-field-edit-profile w-input"
                        maxLength={256}
                        name="last_name"
                        placeholder="Last Name"
                        type="text"
                        id="Name-3"
                        value={formData?.last_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div
                    onClick={handleSubmit}
                    data-wait="Please wait..."
                    className="button-4 w-button"
                    defaultValue="Update"
                  >
                    Save & Continue
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InputModal;
